import React, {FC} from "react";
import style from './button.module.scss';

type ButtonPropsType = {
    disabled?: boolean;
    name: string;
    label: string;
    icon?: string;
    href?: string;
    rounded?: boolean;
    transparent?: boolean;
    onClick?: () => void;
}

type LinkWrapperType = {
    href: string;
}

const LinkWrapper:FC<LinkWrapperType> = ({ href, children }) => <a href={href}>{ children }</a>

export const Button: FC<ButtonPropsType> = (props) =>
{
    const { disabled, name, label, icon, href, rounded, transparent, onClick } = props

    const ButtonComponent = (
        <button
            className={`${style.button} ${style.withIcon} ${rounded ? style.rounded : ''} ${transparent ? style.transparent : ''}`}
            disabled={ Boolean(disabled) }
            name={ name }
            onClick={() => onClick && onClick()}
        >
            { icon && <img src={icon} alt={""}/> }
            { !rounded && label }
        </button>
    );

    return ( href ? <LinkWrapper href={href}>{ ButtonComponent }</LinkWrapper> : ButtonComponent );
}
